export default __webpack_public_path__ + "static/grundfos-ae01c620499d768f95186d677a358483.png";